import { createContext, useEffect, useRef, useState, useCallback } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "react-loading-skeleton/dist/skeleton.css";
import { CHECKOUTPAGE, CONFIRMBOOKING, EVENTSPAGE, HOMEPAGE, MYBOOKINGS, PRE_CHECKOUTPAGE, REDIRECTING, TICKETSPAGE } from "./constants/RoutingPath";
import HomePage from "./pages/HomePage";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./constants/Color/Color.css";
import { useStateWithCallback } from "./hooks/SynchronousUseState";
import ProtectedRoutes from "./utils/ProtectedRoutes";
import EventsPage from "./pages/EventsPage";
import { CITIES_API, PRELOADTEAMS, PRELOADTOURNAMENTS, SPORTSLIST_API, VENUES_API } from "./constants";
import {
  CART_LIST_API,
  COUNTRY_LIST_API,
  GET_ACTIVE_RESERVATION_API,
  getDataFromApi,
  RESERVATION_API,
  USER_PROFILE_API,
  WATCHLIST_ITEM_API,
} from "./APIs";
import Footer from "./components/Footer";
import CookieMsg from "./components/Footer/CookieMsg";
import HeaderNew from "./components/HeaderNew";
import TicketPage from "./pages/TicketPage";
import NotFound from "./pages/NotFound";
import { convertTicketFormat, getDayFromDate } from "./utils/func";
import CheckoutPage from "./pages/CheckoutPage";
import ConfirmBooking from "./pages/ConfirmBooking";
import MyBookings from "./pages/MyBookings";
import AuthPage from "./pages/AuthPage";
import RedirectingPage from "./pages/Redirecting";

export const filterDataContext = createContext(null);

function App() {
  const [minPriceInput, setMinPriceInput] = useStateWithCallback("");
  const [currentSortingTab, setCurrentSortingTab] = useState("");
  const [preloadTournamentData, setPreloadTournamentData] = useState([]);
  const [maxPriceInput, setMaxPriceInput] = useStateWithCallback("");
  const [preLoadCities, setPreloadCities] = useState([]);
  const [preLoadVenues, setPreloadVenues] = useState([]);
  const [ticketAvailabiltyInput, setTicketAvailabiltyInput] = useState("");
  const [selectedSport, setSelectedSport] = useStateWithCallback("");
  const [filteredParams, setFilteredParams] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [moreEvents, setMoreEvents] = useState([]);
  const [sportsList, setSportsList] = useState([]);
  const [filteredEventParams, setFilteredEventParams] = useState("");
  const containerRef = useRef(null);
  const [bottomSheetview, setBottomSheetView] = useState(false);
  const [viewMoreClicked, setViewMoreClicked] = useState(false);
  const [filterChips, setFilterChips] = useState([]);
  const [popularData, setPopularData] = useState([]);
  const [showSorting, setShowSorting] = useState(false);
  const [searchResult, setSearchResult] = useState([]);
  const [filterSearchInput, setFilterSearchInput] = useState("");
  const [checkTeamDataLength, setCheckTeamDataLength] = useState(false);
  const [customModel, setCustomModel] = useState(false);
  const [whislistItem, setWhishListItem] = useState([]);
  const [filterLoader, setFilterLoader] = useState(false);
  const [preloadTeams, setPreloadTeams] = useState([]);
  const [reservationData, setReserVationData] = useState([])
  const [cartData, setCartData] = useState([])
  const [cartValidUntil, setCartValidUntil] = useState("")
  const [cartQuantity, setCartQuantity] = useState(0)
  const [alreadyTaken, setAlreayTaken] = useState(false)
  const [profileDetail, setProfileDetail] = useState()
  const [checkoutReserVationId, setCheckoutReservationId] = useState("")
  const [countryData, setCountryData] = useState([])
  const [profileData, setProfileData] = useState([])
  const [timeRemaining, setTimeRemaining] = useState('');
  const [cartDataLoader, setCartDataLoader] = useState(false)
  const [reservationExpiredMsg, setNewReservationExpiredMsg] = useState("")
  const [backupReserveData, setBackupReserveData] = useState([])
  const reservationToastRef = useRef(null);
  const [reservationLoader, setReservationLoader] = useState(false)
  const [stockAvailabilitydata, setStockAvailabilityData] = useState([])
  const [bookingData, setBookingData] = useState([])
  const [preFilledData, setPreFilledData] = useState([])



  const RoutingArray = [
    { pathName: HOMEPAGE, elementName: <HomePage /> },
    { pathName: EVENTSPAGE, elementName: <EventsPage /> },
    { pathName: `${TICKETSPAGE}:id`, elementName: <TicketPage /> },
    { pathName: "*", elementName: <NotFound /> },
    { pathName: CHECKOUTPAGE, elementName: <CheckoutPage /> },
    { pathName: PRE_CHECKOUTPAGE, elementName: <CheckoutPage /> },
    { pathName: `${CONFIRMBOOKING}/:id`, elementName: <ConfirmBooking /> },
    { pathName: `${MYBOOKINGS}`, elementName: <MyBookings /> },
  ];

  const getAndSetData = async (url) => {
    let response = await getDataFromApi(url);
    if (response) {
      return response.data.data;
    }
  };

  useEffect(() => {
    getAndSetData(SPORTSLIST_API).then(setSportsList);
    getAndSetData(CITIES_API).then(setPreloadCities);
    getAndSetData(VENUES_API).then(setPreloadVenues);
    getAndSetData(PRELOADTEAMS).then(setPreloadTeams);
    getAndSetData(PRELOADTOURNAMENTS).then(setPreloadTournamentData);
    fetchWatchListItem()
    fetchCountryList()
    fetchUserProfile()
    fetchActiveReservation()
  }, []);

  useEffect(() => {
    if (cartData.length > 0 && !alreadyTaken) {
      const convertCartDataToReservation = cartData?.map((item) => {
        return (
          {
            ticket_id: item?.ticket_id,
            quantity: item?.quantity,
            categoryId: item?.category_id,
            event_id: item?.event_id,
            ticketName: item?.eventdays === "singleday"
              ? getDayFromDate(item?.ticket_validfrom)
              : convertTicketFormat(item?.eventdays)
          }
        )
      })
      if (convertCartDataToReservation) {
        setReserVationData(convertCartDataToReservation)
        setBackupReserveData(convertCartDataToReservation)
        setAlreayTaken(true)
      }
    }
  }, [cartData])

  const fetchCartList = async () => {
    setCartData([])
    setCartQuantity(0)
    setCartValidUntil("")
    setCartDataLoader(true)
    try {
      const response = await CART_LIST_API()
      if (response?.status) {
        const cartData = response?.data?.items
        setPreFilledData(JSON.parse(response?.data?.temp_guest_info))
        setCartValidUntil(response?.data?.valid_until_Ind)
        setCartData(cartData)
        setCartQuantity(response?.data?.totalTicketQuantity)
        setCheckoutReservationId(response?.data?.reservation_id)
      } else {
        if (response?.message === "No reservation found" || response?.message === "Reservation time is over") {
          setReserVationData([])
          setBackupReserveData([])
        }
      }
    } catch (error) {
      console.log(error, "CART_LIST")
    } finally {
      setCartDataLoader(false)
    }
  }

  const fetchCountryList = async () => {
    try {
      const response = await COUNTRY_LIST_API()
      if (response && response?.status) {
        setCountryData(response?.data)
      }
    } catch (error) {
      console.log(error, "COUNTRY_LIST")
    }
  }

  const fetchUserProfile = async () => {
    try {
      const response = await USER_PROFILE_API()
      if (response && response?.status) {
        setProfileData(response?.data)
      }
    } catch (error) {
      console.log(error, "USER_PROFILE")
    }
  }

  const fetchWatchListItem = async () => {
    try {
      setWhishListItem([])
      const response = await WATCHLIST_ITEM_API();
      if (response && response.status) {
        for (let i = 0; i < response.data.length; i++) {
          const element = response.data[i];
          if (element.category_id) {
            setWhishListItem((items) => [...items, { id: element?.id, categoryId: element.category_id, categoryName: element?.category_name, eventName: element?.event_name }]);
          } else if (element.event_id) {
            setWhishListItem((items) => [...items, { id: element?.id, event_id: element.event_id, eventName: element?.event_name, season: "20-25" }]);
          }
        }
      }
    } catch (error) {
      console.log(error, "WATCHLIST_ITEM");
    }
  };

  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  };

  const reserveTicket = useCallback(
    debounce(async (data) => {
      setNewReservationExpiredMsg("");
      if (!reservationToastRef.current) {
        reservationToastRef.current = toast.loading("Updating reservation...");
      }

      try {
        const payload = { items: data };
        setStockAvailabilityData([])
        setReservationLoader(true)
        setCheckoutReservationId("")
        const response = await RESERVATION_API(payload);
        if (response && response?.status) {
          setCheckoutReservationId(response?.data?.reservation_id)
          toast.update(reservationToastRef.current, {
            render: "Your ticket has been added to the cart or go to the cart",
            type: "success",
            isLoading: false,
            autoClose: 2000
          });
          reservationToastRef.current = null
        } else {
          // setReserVationData(backupReserveData);
          if (response?.statusCode === 422) {
            setStockAvailabilityData(response?.data?.items)
          }
          if (response?.message) {
            toast.update(reservationToastRef.current, {
              render: response?.message || "Failed to update reservation.",
              type: "error",
              isLoading: false,
              autoClose: 2000
            });
            reservationToastRef.current = null
          }
        }
      } catch (error) {
        console.log(error, "RESERVATION_API");
      } finally {
        fetchCartList()
        setReservationLoader(false)
      }
    }, 2000),
    []
  );

  const fetchActiveReservation = async () => {
    try {
      const response = await GET_ACTIVE_RESERVATION_API()
      if (response && response?.status) {
        setCheckoutReservationId(response?.data?.reservation_id)
      }
    } catch (error) {
      console.log(error, "errorrr")
    }
  }


  return (
    <filterDataContext.Provider
      value={{
        minPriceInput,
        setMinPriceInput,
        maxPriceInput,
        setMaxPriceInput,
        selectedSport,
        setSelectedSport,
        filteredParams,
        setFilteredParams,
        ticketAvailabiltyInput,
        setTicketAvailabiltyInput,
        filteredEvents,
        setFilteredEvents,
        sportsList,
        setSportsList,
        preLoadCities,
        setPreloadCities,
        preLoadVenues,
        setPreloadVenues,
        moreEvents,
        setMoreEvents,
        preloadTournamentData,
        setPreloadTournamentData,
        filteredEventParams,
        setFilteredEventParams,
        containerRef,
        preLoadVenues,
        setPreloadVenues,
        bottomSheetview,
        setBottomSheetView,
        currentSortingTab,
        setCurrentSortingTab,
        viewMoreClicked,
        setViewMoreClicked,
        filterChips,
        setFilterChips,
        popularData,
        setPopularData,
        currentSortingTab,
        setCurrentSortingTab,
        showSorting,
        setShowSorting,
        searchResult,
        setSearchResult,
        filterSearchInput,
        setFilterSearchInput,
        checkTeamDataLength,
        setCheckTeamDataLength,
        customModel,
        setCustomModel,
        whislistItem,
        setWhishListItem,
        filterLoader,
        setFilterLoader,
        preloadTeams,
        setPreloadTeams,
        reservationData, setReserVationData,
        cartData, setCartData,
        cartValidUntil, setCartValidUntil,
        cartQuantity, setCartQuantity,
        fetchCartList,
        fetchWatchListItem,
        profileDetail, setProfileDetail,
        checkoutReserVationId, setCheckoutReservationId,
        countryData,
        profileData,
        setTimeRemaining,
        timeRemaining,
        cartDataLoader,
        reserveTicket,
        setBackupReserveData,
        backupReserveData,
        reservationExpiredMsg, setNewReservationExpiredMsg, reservationToastRef,
        reservationLoader, setReservationLoader,
        stockAvailabilitydata, setStockAvailabilityData,
        bookingData, setBookingData,
        preFilledData, setPreFilledData
      }}
    >
      <BrowserRouter>
        <ToastContainer
          autoClose={3000}
          position="top-right"
          closeButton={true}
          style={{ fontSize: "24px" }}
        />
        <HeaderNew />
        <Routes>
          <Route >
            {/* <Route element={<ProtectedRoutes />}> */}
            {RoutingArray?.map(({ pathName, elementName }) => (
              <Route
                key={pathName}
                path={pathName}
                element={elementName}
              />
            ))}
          </Route>
          <Route path="/auth" element={<AuthPage />} />
          <Route path={REDIRECTING} element={<RedirectingPage />} />
        </Routes>
        <Footer />
        <CookieMsg />
      </BrowserRouter>
    </filterDataContext.Provider>
  );
}

export default App;
